import apiBaseState from "~/constants/apiBaseState";
import moment from "moment";
import Vueset from "~/utils/Vueset";

export const state = () => ({
  tasks: {
    data: null,
    loading: false
  },
  theme: null,
  faqs: [],
  projectState: apiBaseState(),
  projectListState: apiBaseState(),
});

export const getters = {
  tasks(state) {
    return state.tasks;
  },
  communityName(state){
    if(!state.theme){
      return '';
    }
    return state.theme.config.communityName;
  },
  projects(state){
    if(!state.projectListState.data){
      return [];
    }
    const result = [];

    for (const accountName in state.projectListState.data) {
      if (state.projectListState.data.hasOwnProperty(accountName)) {
        const projects = state.projectListState.data[accountName].map(project => ({
          name: project.name,
          slug: project.slug,
          path: project.path
        }));

        result.push({
          accountName: accountName,
          projects: projects
        });
      }
    }

    return result;
  }
};

export const mutations = {
  UPDATE_TASK_BY_ID(state, payload){
    const index = state.projectState.data.data.findIndex(task => task.id === payload.id);
    if(index > -1){
      Vueset(state.projectState.data.data, index, payload);
    }
  },
  MARK_TASK_AS_COMPLETE(state, taskSlug) {
    const matchedIndex = state.projectState.data.data.findIndex(task => task.slug === taskSlug);
    if(matchedIndex > -1){
      state.projectState.data.data[matchedIndex].task_status = 'COMPLETED';
      state.projectState.data.data[matchedIndex].task_status_label = 'Completed';
      state.projectState.data.data[matchedIndex].accepted_at = moment().format("YYYY-MM-DD HH:mm:ss");
      state.projectState.data.data[matchedIndex].completed_at = moment().format("YYYY-MM-DD HH:mm:ss");
    }
  },
  SET_TASKS(state, data) {
    state.tasks.data = data;
  },
  SET_THEME(state, data) {
    state.theme = data;
  },
  SET_FAQS(state, data) {
    state.faqs = data;
  },
  SET_PARTICIPANT_TASKS_LOADING(state, data){
    state.tasks.loading = data;
  },
  SET_PROJECT_STATE(state, data) {
    state.projectState = data;
  },
  SET_PROJECT_LIST_STATE(state, data) {
    state.projectListState = data;
  },
};

export const actions = {
  GET_PARTICIPANT_PROJECT(state, data) {
    const {type, status, project, theme} = data;
    const url = `/participant/dashboard`;

    return this.$whyApi.get({
      url,
      params: {
        type,
        status,
        project,
        theme
      },
      mutation: "participant/SET_PROJECT_STATE",
      errorMessage: "Error getting project data",
      notify: this.$notify
    });
  },
  GET_PARTICIPANT_PROJECT_LIST(state) {
    const url = `/participant/projects`;
    return this.$whyApi.get({
      url,
      mutation: "participant/SET_PROJECT_LIST_STATE",
      errorMessage: "Error getting project list",
      notify: this.$notify
    });
  },
};
